import { ApiMethod } from 'services/api';
import { useRestMutation } from 'utils/hooks/api/useRestMutation';

export const IN_APP_RECALL_URL = '/inappcampaigns/recall';

export const useInAppRecallMutation = () => {
  const { isLoading, mutate, error } = useRestMutation(IN_APP_RECALL_URL, ApiMethod.post);
  return { isLoading, mutate, error };
};
